import { DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface InfoSectionWrapperProps {
  backgroundColor: string
}

export const InfoSectionWrapper = styled.div<InfoSectionWrapperProps>`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  margin-top: ${Spacing.S24};
  padding: ${Spacing.S12};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${({ backgroundColor }) => backgroundColor};
`
